const reviewsData = [
  {
    id: 1,
    name: "Abel Doe",
    date: "4 April 2023",
    review: "Elegant design, premium sound. Worth it!.",
    rateCount: 5,
  },
  {
    id: 2,
    name: "John Doe",
    date: "15 July 2023",
    review: "Noise-cancelling bliss, fits perfectly. Game-changer!",
    rateCount: 5,
  },
  {
    id: 3,
    name: "Jane Doe",
    date: "10 June 2022",
    review: "Crystal-clear audio, upgraded performance. Impressive upgrade",
    rateCount: 4,
  },
  {
    id: 4,
    name: "Shivon Royce",
    date: "6 May 2023",
    review: "Improved sound, easy to use. Fantastic!",
    rateCount: 4,
  },
  {
    id: 5,
    name: "Jerry Kim",
    date: "27 April 2023",
    review: "Seamless, wireless music. Love my AirPods!",
    rateCount: 3,
  },
];

export default reviewsData;
